// src/components/UKK/UKK.jsx
import Accordion from '../../components/Accordion/Accordion';
import Header from '../../components/Headers/UKKHeader';
import UKKHelmetComponent from './UKKHelmetComponent';
import { Link } from "react-router-dom";

/* eslint-disable react-refresh/only-export-components */
const UKK = () => {
    return (
        <>
            <section>
                <UKKHelmetComponent />
                <Header />

                <div className="relative z-10 max-w-5xl mx-auto p-4 bg-primary dark:bg-violet bg-opacity-75 dark:bg-opacity-75 shadow-md mb-10">
                    
                    {/* VUOKRAUS JA PALVELUT */}
                    <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary text-3xl font-bold mb-6">
                        Vuokraus ja palvelut
                    </h2>

                    <div className='flex'>
                        <>
                          <Accordion 
                            title="Miten vuokraan?" 
                            answer={
                              <>
                                Aloita valitsemalla haluamasi <strong>vuokrausajankohta</strong> <Link to="/vuokrattavat" className="underline">vuokrattavat-sivun</Link> yläreunasta. Näet heti, mitkä laitteet ovat saatavilla – varatut tuotteet on merkitty punaisella <strong>VARATTU</strong>-kyltillä. <br /><br />
                                Lisää sopivat tuotteet <strong>vuokrauskoriin</strong> ja siirry <Link to="/tee-varaus" className="underline">tee-varaus-sivulle</Link>. Täytä lomake huolellisesti ja lähetä se meille. <br /><br />
                                Alustava varaus on voimassa <strong>2 tuntia</strong>. Saat sähköpostiisi vahvistuksen, johon vastaamalla varauksesi muuttuu sitovaksi.
                              </>
                            }
                          />
                        </>
                    </div>

                  <div className='flex'>
                    <Accordion
                      title="Miten voin toimia vuokraajana?"
                      answer={
                        <>
                        Haluatko pistää käyttämättömät laitteet töihin? <br /><br />
                        Ota meihin yhteyttä <Link to="/tee-varaus" className="underline">täältä</Link> tai suoraan sähköpostilla/puhelimitse. Käymme laitteesi läpi ja sovimme vuokrausehdoista. <br />
                        Spiderlegs hoitaa kaiken asiakasviestinnän puolestasi ja ilmoittaa sinulle aina, kun varaus tehdään. <br /><br />
                        Vuokrauksen jälkeen asiakas maksaa summan Spiderlegsille, josta oma osuutesi tilitetään sinulle. Provisio on 20 % ja aktiivisille vuokraajille jopa 10 %. Ei piilokuluja, ei vaivaa. <br />
                      
                        <div className="bg-red-100 dark:bg-red-800/20 border border-red-300 dark:border-red-500 text-red-800 dark:text-red-200 p-4 rounded-xl text-sm mt-4">
                          <strong>⚠️ Tärkeää:</strong> Palvelu perustuu <strong>luottamukseen</strong> – sinun vastuullasi on, että ilmoittamasi laitteet ovat toimintakuntoisia ja noudettavissa sovitusti. 
                          Mikäli näitä ehtoja rikotaan (esim. laitetta ei löydy tai se ei toimi), seuraa siitä <strong>elinikäinen porttikielto</strong> sivustolle.
                        </div>
                      </>
                      
                      }
                    />
                  </div>

                    <div className='flex'>
                    <Accordion
                      title="Miten kuljetuspalvelunne toimii?"
                      answer={
                        <>
                          Tarjoamme joustavan kuljetuspalvelun kaikkien vuokrattavien laitteiden toimitukseen. Kuljetus tapahtuu joko henkilöautolla (<strong>kilometrikorvaus</strong>) tai kuomukärryllä (<strong>kilometrikorvaus + 20€ per suunta jos laitteiden määrä ylittää 5 kpl.</strong>).
                          <br /><br />
                          Voit myös noutaa laitteet itse ja tarvittaessa <strong>vuokrata HIRVI 350 -kuomukärryn</strong>.
                          <br /><br />
                          ✅ Kuljetustarpeen voit ilmoittaa <strong>varauslomakkeella</strong> <Link to="/tee-varaus" className="underline">tee-varaus-sivulla</Link>.
                          <br />
                          👉 <Link to="/palvelut#kuljetuspalvelu" className="underline">Lue lisää kuljetuspalvelustamme</Link>
                        </>
                      }
                    />

                    </div>

                    <div className='flex'>
                    <Accordion 
                      title="Voitteko tulla kytkemään laitteet toimintakuntoon juhlapaikalle?" 
                      answer={
                        <>
                          Kyllä! Tarjoamme <strong>asennus- ja opastuspalvelun</strong> kuljetuksen yhteydessä. Me kytkemme ja testaamme laitteet sekä neuvomme käytössä paikan päällä.
                          <br /><br />
                          👉 <Link to="/palvelut#opastuspalvelu" className="underline">Lue lisää palvelusta</Link>
                        </>
                      }
                    />
                    </div>

                    <div className='flex'>
                      <Accordion 
                        title="Mitä minun tulee ottaa huomioon äänentoistolaitteita vuokratessa?" 
                        answer={
                          <>
                            Ennen vuokrausta mieti hetki käytännön asioita: 
                            <br /><br />
                            ✅ <strong>Miten kuljetan laitteet?</strong> – Voit noutaa ne itse tai valita meidän <a href="/#kuljetuspalvelu" className="underline">kuljetuspalvelun</a>, jolloin me tuomme ja tarvittaessa myös asennamme kaiken. 
                            <br /><br />
                            ✅ <strong>Tarvitsenko apua käytössä?</strong> – Tarjoamme <a href="/#opastuspalvelu" className="underline">asennus- ja opastuspalvelun</a>, jossa laitteet kytketään valmiiksi ja saat selkeät käyttöohjeet.
                            <br /><br />
                            ✅ <strong>Onko laitteisto riittävän tehokas?</strong> – Kerro meille tapahtuman koko, paikka ja tarkoitus, niin autamme valitsemaan oikean kokoonpanon – olipa kyseessä juhlat sisällä, ulkona tai vaikka puhetilaisuus.
                            <br /><br />
                            Nämä asiat miettimällä varmistat, että saat toimivan ja stressittömän ratkaisun juuri sinun tapahtumaasi.
                          </>
                        } 
                      />
                    </div>

                    <div className='flex'>
                    <Accordion 
                        title="Voinko vuokrata mikrofonin ja telineen?" 
                        answer={
                          <>
                            Kyllä! <strong>Mikrofonit ja mikrofonitelineet</strong> löytyvät <a href="/vuokrattavat#otherrentals" className="underline">Muut vuokrattavat</a> -osiosta <strong>vuokrattavat</strong>-sivulla.
                            <br /><br />
                            Voit lisätä ne helposti mukaan varaukseesi muiden laitteiden ohella. Suosittelemme tekemään varauksen ajoissa, jotta varmistat saatavuuden.
                          </>
                        }
                      />

                    </div>


                    {/* BÄNDIEN JA ESIINTYJIEN YHTEISTYÖ */}
                    <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary text-3xl font-bold mt-10 mb-6">
                        Bändien ja esiintyjien yhteistyö
                    </h2>

                    <div className='flex'>
                    <Accordion 
                        title="Kuinka voin liittyä Spiderlegs Productionsin välityspalveluun?" 
                        answer="Ota meihin yhteyttä, niin sovimme ajan lyhyelle Teams-tapaamiselle. Tapaamisen aikana esittelemme palvelun toiminnan, käymme läpi yhteistyön periaatteet ja vastaamme mahdollisiin kysymyksiisi. Näin varmistamme, että palvelu sopii tarpeisiisi ja että yhteistyö alkaa sujuvasti."
                      />
                    </div>

                    <div className='flex'>
                      <Accordion
                      title="Miten keikkakyselyt ja tarjoukset toimivat?"
                      answer={
                        <>
                          <p>Asiakas voi lähettää tarjouspyynnön valitsemalla vapaan päivän esiintyjän kalenterista.</p>
                          <p>Tämän jälkeen asiakas valitsee haluamansa esiintymisvaihtoehdon (esim. 2×45 min) esiintyjän ilmoittamista vaihtoehdoista.</p>
                          <p>Esiintyjä hinnoittelee itse keikkansa ja määrittää alueet, joilla on valmis keikkailemaan. Keikkahintaan tulee sisällyttää kaikki kustannukset mm. esiintyminen, matkakulut ja äänentoisto jne.</p>
                          <p>Asiakas saa tarjouksen suoraan sähköpostiinsa määrittelemilläsi hinnoilla. Mikäli asiakas on kiinnostunut, siirtyy varsinainen keikkaneuvottelu Spiderlegsiltä suoraan esiintyjälle.</p>
                        </>
                      }
                      />
                    </div>

                    <div className="flex">
                      <Accordion
                        title="Mitä eroa on Basic- ja Premium-tilauksella?"
                        answer={
                          <>
                            Molemmat tilaukset sisältävät keikkakalenterin ja mahdollisuuden esiintyjäprofiiliin. Premium-tilauksella saat lisäksi gallerian, videot, ääninäytteet, tähtiarvostelut ja paremman näkyvyyden.
                            <br />
                            <Link
                              to="/liity"
                              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                              className="inline-block mt-2 underline text-linkcol dark:text-yellow-400 hover:text-yellow-600 transition-colors duration-200"
                            >
                              Katso lisää tilausvaihtoehdoista
                            </Link>
                          </>
                        }
                      />
                    </div>

                    {/* KEIKKAPERUUTUKSET JA SOPIMUKSET */}
                    <h2 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary text-3xl font-bold mt-10 mb-6">
                        Keikkaperuutukset ja sopimukset
                    </h2>

                    <div className='flex'>
                      <Accordion 
                        title="Mitä tapahtuu, jos bändi joutuu perumaan keikan?" 
                        answer={
                          <>
                            Esiintyjällä on ensisijainen vastuu keikan toteutumisesta. Mikäli joku bändin jäsen on estynyt tai sairastuu, esiintyjän velvollisuus on pyrkiä järjestämään korvaava muusikko tilalle.

                            <br /><br />

                            Jos koko keikka joudutaan perumaan, asiasta tulee ilmoittaa välittömästi Spiderlegs Productionsille. Tällöin pyrimme etsimään asiakkaalle korvaavan esiintyjän, jotta tapahtuma voi toteutua suunnitellusti.

                            <br /><br />

                            Mikäli sopivaa korvaajaa ei löydy tai asiakas ei hyväksy uutta ehdotusta, asiakkaalle palautetaan mahdollinen varausmaksu täysimääräisesti.

                            <br /><br />

                            Varausmaksu palautetaan vain silloin, kun keikan peruuntuminen johtuu esiintyjästä – ei esimerkiksi asiakkaan perumisesta tai muutoksista tapahtumaan.
                          </>
                        }
                      />
                    </div>

                    <div className='flex'>
                      <Accordion 
                        title="Miten varmistetaan, että keikka toteutuu sovitusti?" 
                        answer="Jokaisesta keikasta tehdään sopimus esiintyjän ja asiakkaan välille. Sopimukseen kirjataan kaikki keikan kannalta olennaiset tiedot: ajankohta, paikka, kesto, palkkio sekä mahdollinen varausmaksu. Varausmaksu vahvistaa molempien osapuolten sitoutumisen ja vähentää peruutusten riskiä.

                    Spiderlegs Productions toimii alustana ja tukena sopimusprosessissa ja tarjoaa mallipohjat sopimusten tekemiseen. Lisäksi Spiderlegs solmii erillisen palvelusopimuksen jokaisen esiintyjän kanssa tämän liittyessä palveluun." 
                      />
                    </div>

                </div>
            </section>
        </>
    );
};

export default UKK;
